import React from 'react';
import { Hero } from '../components/sections/Hero';
import { Features } from '../components/sections/Features';
import { Historia } from '../components/sections/Historia';
import { Card } from '../components/ui/Card';
import { SectionTitle } from '../components/ui/SectionTitle';
import { PhoneMockup } from '../components/ui/PhoneMockup';
import { Contacto } from '../components/sections/Contacto';
import { Nosotros } from '../components/sections/Nosotros';
import Footer from '../components/layout/Footer';

export function Home() {
    return (
        <main className="bg-sp-light">
            <br />

            <Hero />

            {/* Sección de features (beneficios) */}
            <Features />

            {/* Cards grid */}
            <section className="max-w-[1100px] mx-auto px-6 py-12" id="que-ofrecemos">
                <SectionTitle subtitle="Todo lo que incluye tu SmartPet">
                    ¿Qué ofrecemos?
                </SectionTitle>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    <Card icon="🔔" title="Alerta Instantánea">
                        Notificación con fecha, hora y ubicación exacta del escaneo.
                    </Card>
                    <Card icon="🏥" title="Ficha Médica">
                        Alergias, condiciones y contacto de veterinaria en el perfil.
                    </Card>
                    <Card icon="📱" title="Sin App">
                        Quien encuentra a tu mascota no necesita instalar nada.
                    </Card>
                </div>
            </section>

            {/* Video con mockup - FONDO DE ANCHO COMPLETO */}
            <section className="w-full bg-sp-dark py-12 md:py-16" id="como-funciona">
                <div className="max-w-[1100px] mx-auto px-6 text-center">
                    <div className="text-center mb-8">
                        <span className="text-sm font-bold text-white/70 uppercase tracking-widest">
                            Así se ve el perfil de tu mascota
                        </span>
                        <h2 className="text-3xl md:text-4xl font-black text-white mt-1">
                            Mirá cómo funciona
                        </h2>
                    </div>
                    <div className="flex justify-center">
                        <PhoneMockup>
                            <video
                                className="w-full h-full object-cover"
                                controls
                                autoPlay
                                loop
                                playsInline
                                aria-label="Video explicativo de cómo funciona SmartPet"
                            >
                                <source src="/assets/video/funcionamiento.mp4" type="video/mp4" />
                                Tu navegador no soporta el video.
                            </video>
                        </PhoneMockup>
                    </div>
                </div>
            </section>

            {/* Sección Historia (tu historia personal) */}
            <Historia />

            {/* Sección Nosotros (misión, visión, valores) */}
            <Nosotros />
            {/* 
            <Contacto /> */}
            <Footer />
        </main>
    );
}